import IconChevronDown from '@apollo/icons/default/IconChevronDown.svg';
import { Button } from '@apollo/orbit';
import { List } from '@apollo/space-kit/List';
import { ListItem } from '@apollo/space-kit/ListItem';
import { Popover } from '@apollo/space-kit/Popover';
import React from 'react';

export const WrapDiffLinesDropdown = ({
  shouldWrapLines,
  setShouldWrapLines,
}: {
  shouldWrapLines: boolean;
  setShouldWrapLines: React.Dispatch<React.SetStateAction<boolean>>;
}) => (
  // TODO(chakra-menu): This can be made into a menu but we will want to set up a selectable variant here probably
  <Popover
    placement="bottom-start"
    content={
      <List>
        <ListItem
          selected={!shouldWrapLines}
          onClick={() => {
            setShouldWrapLines(false);
          }}
          key="no-line-wrap"
        >
          No line wrap
        </ListItem>
        <ListItem
          selected={shouldWrapLines}
          onClick={() => {
            setShouldWrapLines(true);
          }}
          key="line-wrap"
        >
          Line wrap
        </ListItem>
      </List>
    }
    trigger={
      <Button
        size="sm"
        className="mr-4"
        variant="secondary"
        rightIcon={<IconChevronDown />}
      >
        {shouldWrapLines ? 'Line wrap' : 'No line wrap'}
      </Button>
    }
  />
);
